import { FC } from 'react';
import { useNavigate } from 'react-router-dom';

import styles from 'components/PageLayout/ContentWithBackButton/ContentWithBackButton.module.scss';
import BackButton from 'components/curo-components/common/BackButton';
import { CuroAppRoute } from 'enums/curo/CuroAppRoute';

interface IFormTitleProps {
  title: string;
  children: string | JSX.Element | React.ReactElement;
}

const ContentWithBackButton: FC<IFormTitleProps> = ({ title, children }) => {
  const navigate = useNavigate();
  return (
    <div className={styles.contentWithBack}>
      <div className={styles.contentHeader}>
        <BackButton
          className={styles.backButton}
          onClick={() => navigate(CuroAppRoute.TermsAndConditions)}
        />
        <div className={styles.formTitle}>{title}</div>
      </div>
      <div className={styles.contentWrapper}>{children}</div>
    </div>
  );
};

export default ContentWithBackButton;
